import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a2a10ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "account-message-container"
};
const _hoisted_2 = {
  class: "info-box",
  id: "InfoBox"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "公众号信息", -1));
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { getAccountById } from '@/api/account';
export default {
  __name: 'account-message',
  setup(__props) {
    const route = useRoute();
    const accountMsg = ref({});
    const getAccountByIdData = async () => {
      const res = await getAccountById(route.params.accountId);
      accountMsg.value = res;
    };
    getAccountByIdData();

    // 打印相关
    const printLoading = ref(false);
    const printObj = {
      // 打印区域
      id: 'InfoBox',
      // 打印标题
      popTitle: '',
      // 打印前
      beforeOpenCallback(vue) {
        printLoading.value = true;
      },
      // 执行打印
      openCallback(vue) {
        printLoading.value = false;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _directive_print = _resolveDirective("print");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        class: "print-box"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          loading: printLoading.value
        }, {
          default: _withCtx(() => [_createTextVNode("打印")]),
          _: 1
        }, 8, ["loading"])), [[_directive_print, printObj]])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_descriptions, {
          column: 2,
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            label: "名称"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.name), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "状态"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.statusName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "appId"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.appId), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "path"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.path), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "appSecret"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.appSecret), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "创建时间"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$filters.dateFilter(accountMsg.value.createTime)), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "微信id"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.originalId), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "menu",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.menu), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "微信Service Url",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(`https://patient.igensoft.com.cn/api/yia/v1/wx/handle/${accountMsg.value.path}`), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "微信token",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.token), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "关注欢迎词",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.welcome), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "留言自动回复词",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.auto), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "转人工客服关键字",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(accountMsg.value.service), 1)]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      })]);
    };
  }
};